var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "notes",
    viewBox: "0 0 204 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 130L2 204L35.5 188.538M33.5 130L145.5 18.8682M33.5 130L46.75 143.581M73.5 171L60 157.163M73.5 171L186.5 58M73.5 171L35.5 188.538M60 157.163L172.5 44.5M60 157.163L46.75 143.581M172.5 44.5L186.5 58M172.5 44.5L159 31.6841M145.5 18.8682L159 31.6841M145.5 18.8682L154 10.4341M186.5 58L194.5 50M159 31.6841L46.75 143.581M154 10.4341L162.5 2L202.5 42L194.5 50M154 10.4341L194.5 50M16.6188 169.657L35.5 188.538",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 188.5L16.5 170L2 204.5L35 188.5Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.ed861c5e50c61ea7b3a2d66ffd73e4fe.svg";
export { ForwardRef as ReactComponent };